import React from 'react';
import MasterLayout from '../components/layouts/MasterLayout';
import PageContentLayout from '../components/layouts/PageContentLayout';
import { useUser } from '../contexts/UserContext';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import LoginForm from '../components/user/LoginForm';
import ProfileForm from '../components/user/ProfileForm';

const UserPage = () => {
    const { userLoading, isLogin } = useUser();

    return (
        <MasterLayout>
            <PageContentLayout>
                {userLoading ?
                    (
                        <div style={{ textAlign: 'center' }}>
                            <Spin
                                indicator={
                                    <LoadingOutlined
                                        style={{
                                            fontSize: 48,
                                        }}
                                        spin
                                    />
                                }
                            />
                        </div>
                    )
                    : (
                        isLogin ? (
                            <ProfileForm />
                        ) : (<LoginForm />)
                    )
                }
            </PageContentLayout>
        </MasterLayout>
    );
};

export default UserPage; 
